module.exports = __webpack_public_path__ + "img/Avatar-29.088e6989.svg";